import { Card, CardBody } from "./../../components/card/card.jsx";
import { useEffect, useState } from "react";

function QtyMechanicAll({ data }) {
  const [qty, setQty] = useState(0);
  const [inMp, setInMp] = useState(0);
  const [outMp, setOutMp] = useState(0);
  const [arrow, setArrow] = useState({ theme: "fas fa-ellipsis-h fa-4x", color: "opacity-5 text-theme mx-3" });
  useEffect(() => {
    function settingArrow(data) {
      const diff = data.in - data.out;
      if (diff === 0) setArrow({ theme: "fas fa-ellipsis-h fa-4x", color: "opacity-5 text-theme mx-3" });
      if (diff > 0) setArrow({ theme: "fas fa-long-arrow-alt-up fa-4x", color: "opacity-5 text-theme mx-3" });
      if (diff < 0) setArrow({ theme: "fas fa-long-arrow-alt-down fa-4x", color: "opacity-5 text-danger mx-3" });
    }
    setQty(data.qty);
    settingArrow(data);
    setInMp(data.in);
    setOutMp(data.out);
  }, [data]);
  return (
    <>
      <Card>
        <CardBody className="d-flex align-items-center text-inverse m-5px bg-inverse bg-opacity-10">
          <div className="flex-fill">
            <div className="mb-1">Mechanic Plant Quantity</div>
            <h2>{qty}</h2>
            {inMp > 0 ? <div>{inMp} new Mechanics in the last 30 days.</div> : ""}
            {outMp > 0 ? <div>{outMp} mechanics have left the company in the last 30 days.</div> : ""}
          </div>
          <div className={arrow.color}>
            <i className={arrow.theme}></i>
          </div>
        </CardBody>
      </Card>
    </>
  );
}

export default QtyMechanicAll;
